export const GET_KEY_STAGES = "GET_KEY_STAGES"
export const GET_KEY_STAGES_SUCCESS = "GET_KEY_STAGES_SUCCESS"
export const GET_KEY_STAGES_FAILED = "GET_KEY_STAGES_FAILED"